import {useEffect, useState} from "react";
import {Box, Button, Typography} from "@mui/material";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import TakeoutDiningRoundedIcon from "@mui/icons-material/TakeoutDiningRounded";
import {useNavigate} from "react-router-dom";
import {flushSync} from "react-dom";
import KioskHeader from "../components/KioskHeader";
import TableNumberDialog from "../components/TableNumberDialog";
import {useKioskLang, useKioskSession} from "../context/KioskSessionContext";

export default function ServiceModePage({systemData, online, onHome}) {
  const navigate = useNavigate();
  const {state, dispatch, startSession} = useKioskSession();
  const {tr} = useKioskLang();
  const [tableOpen, setTableOpen] = useState(false);
  const settings = systemData?.kiosk_settings ?? {};
  const modes = [
    settings.allow_dine_in !== false && {method: 3, title: tr("dineIn"), subtitle: tr("dineInText"), icon: <RestaurantRoundedIcon sx={{fontSize: 92}}/>},
    settings.allow_takeout !== false && {method: 2, title: tr("takeout"), subtitle: tr("takeoutText"), icon: <TakeoutDiningRoundedIcon sx={{fontSize: 92}}/>},
  ].filter(Boolean);

  const choose = (method, tableNumber = "") => {
    flushSync(() => dispatch({type: "SET_METHOD", method, tableNumber}));
    navigate("/kiosk/menu");
  };

  //內用先輸入桌號才進菜單，外帶直接進
  const select = (method) => {
    if (Number(method) === 3) {
      setTableOpen(true);
    } else {
      choose(method);
    }
  };

  useEffect(() => {
    if (!state.sessionId) startSession();
  }, [startSession, state.sessionId]);

  return <Box sx={{height: "100dvh", display: "flex", flexDirection: "column"}}>
    <KioskHeader systemData={systemData} onHome={onHome} onBack={() => navigate("/kiosk/welcome")} online={online}/>
    <Box sx={{flex: 1, p: 5, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
      <Typography sx={{fontSize: 42, fontWeight: 950}}>{tr("chooseService")}</Typography>
      <Typography color="text.secondary" sx={{fontSize: 21, mt: 1}}>{tr("chooseServiceHint")}</Typography>
      <Box sx={{width: "min(100%, 900px)", mt: 5, display: "grid", gridTemplateColumns: `repeat(${modes.length}, 1fr)`, gap: 3}}>
        {modes.map((mode) => <Button key={mode.method} onClick={() => select(mode.method)} sx={{height: 330, display: "flex", flexDirection: "column", gap: 2, bgcolor: "#FFF", color: "text.primary", border: "2px solid rgba(80,55,40,.12)", boxShadow: "0 20px 50px rgba(76,49,32,.1)", "&:hover": {bgcolor: "#FFF8F0", borderColor: "primary.main"}}}>
          <Box sx={{color: "primary.main"}}>{mode.icon}</Box>
          <Typography sx={{fontSize: 40, fontWeight: 950}}>{mode.title}</Typography>
          <Typography color="text.secondary" sx={{fontSize: 19}}>{mode.subtitle}</Typography>
        </Button>)}
      </Box>
    </Box>
    <TableNumberDialog open={tableOpen} onClose={() => setTableOpen(false)} onConfirm={(tableNumber) => {setTableOpen(false); choose(3, tableNumber);}}/>
  </Box>;
}
